import { keepPreviousData, useQuery } from "@tanstack/react-query";
import {
  getConfigObject,
  getXtenantId,
  useBaseContent,
} from "../../../utils/utils";
import { SrFaxManagementApi } from "../../../services";

interface UseGetFaxIncomingByUuidByIdProps {
  faxIncomingUuid?: string;
  enabled?: boolean;
}

/**
 *
 * @author Atish Bagate
 */
export function useGetFaxIncomingByUuidById({
  faxIncomingUuid,
  enabled,
}: UseGetFaxIncomingByUuidByIdProps): useBaseContent<any> {
  return useQuery({
    queryKey: ["get-fax-incoming-by-id", faxIncomingUuid],
    enabled: enabled ?? !!faxIncomingUuid,
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    queryFn: async () =>
      new SrFaxManagementApi(getConfigObject())
        .getFaxDocumentById1(faxIncomingUuid!, getXtenantId())
        .then((res) => res?.data),
  });
}
